<template>
  <div class="page_html">
    <div class="banner">
      <img
        src="@/assets/solution/enterprise/solution_banner.png"
        alt=""
      >
      <div class="banner_Title">
        <div class="title">
          {{ title }}
        </div>
        <div class="subtitle">
          {{ subtitle }}
        </div>
      </div>
    </div>

    <div class="introduce">
      <p class="sub_title">
        检测分析类型
      </p>
      <div class="content_A">
        全流量安全监测分析服务可检测分析的类型包括：设备状态、安全态势分析、APT告警、恶意软件告警、网络攻击告警、WebShell告警、局域网安全分析、数据库安全分析、邮件安全分析、爆破行为分析、安全事件深度分析等。
      </div>
    </div>

    <div class="introduce bg">
      <p class="sub_title">
        威胁检测流程
      </p>
      <div class="detection">
        <div class="steps">
          <div
            v-for="step in steps"
            :key="step.id"
            class="step"
          >
            <div class="step_top">
              <div class="title">
                {{ step.title }}
              </div>
              <div
                v-for="item in step.text"
                :key="item"
                class="text"
              >
                {{ item }}
              </div>
            </div>
            <div class="number">
              {{ step.number }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="introduce">
      <p class="sub_title">
        处置和整改建议
      </p>
      <div class="content_A">
        “未知攻、焉知防”，在对安全威胁和安全事件深度分析后，“有的放矢”地给出事件处置和整改建议，帮助客户解决问题并提高安全防御体系的“健壮性”。
      </div>
    </div>

    <div class="introduce">
      <p class="sub_title">
        服务价值
      </p>
      <div class="content_A value">
        <div
          v-for="item in values"
          :key="item"
          class="service"
        >
          <div class="top_title">
            {{ item.title }}
          </div>
          <div
            v-for="text in item.content"
            :key="text"
            class="contents"
          >
            {{ text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FullFlowSafety',
  data() {
    return {
      title: '全流量安全监测分析服务',
      subtitle: '全流量安全监测分析服务基于专业的人员和工具，基于多维度海量互联网数据，进行自动化挖掘与云端关联分析，提前洞悉各种安全威胁，同时能够对包括APT在内的高级威胁的恶意行为实现早期的快速发现，并可对受害目标及攻击源头进行精准定位，最终达到对入侵途径及攻击者背景的研判与溯源。',
      steps: [
        {
          id: 1,
          title: '前期准备阶段',
          text: ['确定监测资产的范围、', '网段以及客户需求，与', '客户签署全流量安全监', '测授权书，拿到授权后', '对客户网络进行全流量', '安全监测。'],
          number: '01'
        },
        {
          id: 2,
          title: '全流量安全监测阶段',
          text: ['信息收集', '监测设备上架', '资产识别', '信息分析'],
          number: '02'
        },
        {
          id: 3,
          title: '测试总结阶段',
          text: ['信息整理', '形成报告'],
          number: '03'
        }

      ],
      values: [
        {
          id: 1,
          title: '技术角度',
          content: [
            '人机结合，“准确”发现和分析“已知”安全威胁；',
            '人机结合，“有效”发现和分析“未知”安全威胁；',
            '有的放矢地给出事件处置和整改建议，帮助客户解决问题并提高安全防御体系的“健壮性”。'
          ]
        },
        {
          id: 2,
          title: '管理角度',
          content: [
            ' 一切没有“技术手段”保障的“管理措施”一定会失效。本服务是安全管理的一个“抓手”，可实现：',
            '指导：检查结果“有的放矢”指导安全管理及技术体系改进；',
            '监督：帮助监督安全管理制度的落实情况，发现违法、违规行为；',
            '考核：检查结果作为证据，促进安全管理考核落地。'
          ]

        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.page_html {
  height: 100%;

  .banner {
    width: 100wh;
    height: 550px;

    img {
      width: 100%;
      height: 100%;
    }

    .banner_Title {
      position: absolute;
      top: 15%;
      left: 15%;
      width: 80%;

      .title {
        width: 80%;
        font-size: 54px;
        color: #ffffff;
        font-weight: bold;
      }

      .subtitle {
        width: 80%;
        font-size: 36px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        margin-top: 50px;
      }

    }
  }

  .detection {
    width: 70%;
    margin: 0 auto;
    display: flex;

    .steps {
      width: 100%;
      display: flex;
      justify-content: space-evenly;

      .step {
        width: 192px;
        height: 480px;
        background: #fff;
        border-radius: 150px;
        box-shadow: 0 0 15px 15px #d9e1fc;
        position: relative;

        &:not(:first-child) {
          .text {
            padding: 0 37px;
          }

          &::after {
            content: "";
            display: block;
            width: 55px;
            height: 38px;
            background-image: url(data:image/jpeg;base64,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);
            background-size: 100% 100%;
            margin-top: 22px px;
            left: -125px;
            position: absolute;
            top: 150px;
          }

        }

        &:first-child {
          .text {
            padding: 0 14px;
          }
        }

        .step_top {
          width: 100%;
          height: 400px;
          background: #ADC9FF;
          border-radius: 150px;
          // text-align: center;
          position: absolute;
          top: 0;

          .title {
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333333;
            margin-top: 60px;
            padding: 0 36px 20px;
          }

          .text {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 30px;

          }
        }

        .number {
          position: absolute;
          font-size: 72px;
          font-family: DIN;
          font-weight: bold;
          color: #4559E9;
          bottom: 0;
          left: calc(50% - 44px);
        }
      }
    }
  }

  .bg {
    background: #FAFBFF;
    padding: 74px 0 46px;
  }

  .value {
    display: flex;
    justify-content: space-between;

    .service {
      width: 44%;
      background: #FAFAFA;
      box-shadow: 1px 1px 10px 10px #dbe3fa;
      padding-bottom: 50px;

      .top_title {
        font-size: 36px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #4559E9;
        text-align: center;
        margin: 66px 0;
      }

      .contents {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        padding: 0 112px;
      }
    }
  }

}

@media screen and (min-width: 1200px) and (max-width: 1350px) {
  .page_html .detection .steps .step:not(:first-child)::after {
    left: -70px;
  }

  .page_html .detection .steps .step .step_top {
    height: 385px;
  }

  .page_html .banner .banner_Title .subtitle ,
  .introduce .content_A{
    font-size: 20px;
  }

  .page_html .banner .banner_Title .title {
    width: 100%;
    font-size: 37px;
  }

  .page_html .value .service .contents {
    padding: 0 68px;
  }

  .page_html .value .service .contents{
    font-size: 18px;
  }
}

@media screen and (min-width: 1350px) and (max-width: 1440px) {
  .page_html .detection .steps .step:not(:first-child)::after {
    left: -75px;
  }

  .page_html .detection .steps .step .step_top {
    height: 385px;
  }

  .page_html .banner .banner_Title .title {
    width: 95%;
    font-size: 40px;
  }

  .page_html .banner .banner_Title .subtitle {
    font-size: 25px;
  }

  .banner{
    height: 450px !important;
  }

  .page_html .value .service .contents {
    padding: 0 69px;
  }

  .page_html .value .service .contents{
    font-size: 18px;
  }
}

@media screen and (min-width: 1440px) and (max-width: 1500px) {
  .page_html .detection .steps .step:not(:first-child)::after {
    left: -85px;
  }

  .page_html .detection .steps .step .step_top {
    height: 385px;
  }

  .page_html .banner .banner_Title .title {
    width: 95%;
    font-size: 42px;
  }

  .page_html .banner .banner_Title .subtitle {
    font-size: 27px;
  }
}

@media screen and (min-width: 1500px) and (max-width: 1700px) {
  .page_html .detection .steps .step:not(:first-child)::after {
    left: -105px;
  }

  .page_html .detection .steps .step .step_top {
    height: 385px;
  }

  .page_html .banner .banner_Title .subtitle {
    font-size: 30px;
  }

  .banner .banner_Title .title {
    font-size: 52px !important;
  }

  .page_html .value .service .contents{
    font-size: 19px;
    padding: 0 81px;
  }
}
</style>
